<script setup lang="ts">
/**
 * Discord-Avatar: runder Kreis, entweder Initiale auf Farbfläche oder das
 * Clarify-Logo für den Bot. Größen wie im Original (40px Messages, 24px kompakt).
 */
withDefaults(defineProps<{
  name: string
  color?: string
  size?: number
  bot?: boolean
  status?: 'online' | 'idle' | 'none'
}>(), {
  color: 'var(--dc-blurple)',
  size: 40,
  bot: false,
  status: 'none'
})
</script>

<template>
  <div class="dc-avatar" :style="{ width: `${size}px`, height: `${size}px` }">
    <img
      v-if="bot"
      src="/brand/clarify-icon-square.svg"
      alt=""
      class="dc-avatar-img"
      :width="size"
      :height="size"
    >
    <!-- Dekorativ: der Name steht immer direkt daneben -->
    <div v-else class="dc-avatar-fallback" aria-hidden="true" :style="{ background: color, fontSize: `${size * 0.4}px` }">
      {{ name.charAt(0).toUpperCase() }}
    </div>
    <span v-if="status !== 'none'" class="dc-avatar-status" :class="`is-${status}`" />
  </div>
</template>

<style scoped>
.dc-avatar {
  position: relative;
  flex-shrink: 0;
}

.dc-avatar-img,
.dc-avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: var(--dc-radius-avatar);
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 600;
  overflow: hidden;
  object-fit: cover;
}

.dc-avatar-status {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 34%;
  height: 34%;
  border-radius: 50%;
  border: 3px solid var(--dc-bg-chat);
}

.dc-avatar-status.is-online {
  background: var(--dc-green);
}

.dc-avatar-status.is-idle {
  background: var(--dc-yellow);
}
</style>
